import styled from 'styled-components';
import { palette } from 'styled-theme';
import WithDirection from '../../../config/withDirection';

export default WithDirection(styled.div`
    margin-right: 11px;
    min-width: 40px;

    button {
        display: flex;
        justify-content: center;
        align-items: center;
        margin: 0;
        border: 1px solid rgba(151, 151, 151, 1);
        width: 40px;
        height: 40px;
        padding: 0;
        background-color: rgba(255, 255, 255, 1);
        border-radius: 40px;
        transition: .3s;
    }
    button:hover { background-color: rgba(239, 239, 239, 1); }
    button img { width: 18px; }

    @media screen and (max-width: 767px) {
        margin-right: 8px;
    }
`);


// WEBPACK FOOTER //
// ./src/containers/AsoAnalytic/AppScoreReport/Wrapper.js